import { useNavigate } from 'react-router-dom';
import { Button, LogOutIcon } from '@practium/ui';
import { useForBinding } from '../contexts/ForBindingContext';
import styles from './ForBindingBanner.module.css';

const ROLE_LABELS: Record<string, string> = {
	farmer: 'Agricultor',
	consultant: 'Consultor',
	company: 'Empresa',
	admin: 'Administrador',
	master: 'Master',
};

export const ForBindingBanner = () => {
	const navigate = useNavigate();
	const { isForBinding, forBindingUser, exitProfile } = useForBinding();

	if (!isForBinding || !forBindingUser) return null;

	const fullName = `${forBindingUser.name} ${forBindingUser.surName}`.trim();
	const roleLabel = ROLE_LABELS[forBindingUser.role ?? ''] ?? 'Usuário';

	const handleExit = () => {
		exitProfile();
		navigate('/');
	};

	return (
		<div className={styles.banner}>
			<p className={styles.text}>
				Você está acessando a conta de <span className={styles.name}>{fullName}</span> (
				{roleLabel})
			</p>
			<Button
				variant="outline"
				className={styles.exitButton}
				icon={<LogOutIcon width={16} height={16} />}
				onClick={handleExit}
			>
				Sair da conta
			</Button>
		</div>
	);
};
